import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1535254973040-607b474cb50d?q=80&w=2000&auto=format&fit=crop';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-banner">
        <img
          src={HERO_IMAGE}
          alt="Alka's CakeWalk - Handcrafted Cakes"
          className="hero-featured-image"
        />
        <div className="hero-overlay">
          <h1 className="hero-title">Alka's CakeWalk</h1>
          <p className="hero-subtitle">
            Handcrafted cakes baked with love, passion, and the finest ingredients.
            Celebrating 5 glorious years of making your celebrations sweeter.
          </p>
          <div className="hero-buttons">
            <Link to="/menu" className="hero-cta-btn primary">
              Explore Menu
            </Link>
            <a
              href="https://wa.me/918668281565?text=Hi!%20I'd%20like%20to%20order%20a%20cake"
              target="_blank"
              rel="noopener noreferrer"
              className="hero-cta-btn secondary"
            >
              Order Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
